import React, { useState } from 'react';
import { Container, Box, CircularProgress, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import {
  BackgroundContainer,
  Overlay,
  FormContainer,
  LogoContainer,
  ContentContainer,
  LogoImage,
} from './styles';
import logo from '../../assets/img/logo_v3.png';
import providerLogo from '../../assets/img/logo_connect_v1.png';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const handleLoginConnect = () => {
    setLoading(true);
    const currentUrl = encodeURIComponent(window.location.href);
    const env = process.env.NODE_ENV;
    let targetUrl = '';
  
    if (env === 'development') {
      targetUrl = `http://localhost:3000/login?redirect=${currentUrl}`;
      console.log(targetUrl);
    } else {
      targetUrl = `https://connect.publisol.com.br/login?redirect=${currentUrl}`;
    }
  
    window.location.href = targetUrl;
  };
  

  return (
    <BackgroundContainer>
      <Overlay />
      <Container
        maxWidth="xs"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          zIndex: 1,
        }}
      >
        <FormContainer>
          <LogoContainer>
            <LogoImage src={logo} alt="Logo" />
          </LogoContainer>

          <ContentContainer>
            <Box sx={{ position: 'relative' }}>
              <Typography component="p" textAlign="center" sx={{ mb: 2 }}>
                Faça login com sua conta Publisol
              </Typography>

              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="medium"
                type="button"
                disabled={loading}
                onClick={handleLoginConnect}
                sx={{
                  paddingY: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size={32} />
                ) : (
                  <>
                    Entrar com
                    <img
                      src={providerLogo}
                      alt="Provider Logo"
                      style={{ height: '42px', marginLeft: '8px' }}
                    />
                  </>
                )}
              </Button>
            </Box>
          </ContentContainer>
        </FormContainer>
      </Container>
    </BackgroundContainer>
  );
};

export default Login;